var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3032 28.6448H14.2406C6.41265 28.6448 0.0439453 22.2761 0.0439453 14.4482V14.3856C0.0439453 6.55764 6.41265 0.188965 14.2406 0.188965H14.3032C22.1311 0.188965 28.4998 6.55764 28.4998 14.3856V14.4482C28.4998 22.2761 22.1311 28.6448 14.3032 28.6448ZM14.2406 1.15217C6.94337 1.15217 1.00715 7.08836 1.00715 14.3856V14.4482C1.00715 21.7454 6.94337 27.6816 14.2406 27.6816H14.3032C21.6004 27.6816 27.5366 21.7454 27.5366 14.4482V14.3856C27.5366 7.08836 21.6004 1.15217 14.3032 1.15217H14.2406Z",
    fill: "#404040"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 8.55029,
    width: 16,
    height: 12,
    rx: 2,
    stroke: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11.5503L13.6056 15.1031C14.1686 15.3846 14.8314 15.3846 15.3944 15.1031L22.5 11.5503",
    stroke: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedin);
export default __webpack_public_path__ + "static/media/footer-Linkedin.edec44925f8ff4a15f86dfb96d909b35.svg";
export { ForwardRef as ReactComponent };